module.exports = __webpack_public_path__ + "static/media/Bangladesh.0588ba40.png";